import { Donvitructhuoc } from './dmdonvitructhuoc';
import { QlttLinhVuc } from './qlttlinhvuc';

export class Thutuchanhchinh {
  id: number;
  ma: String;
  stt: number;
  ten: string;
  cosophaply: string;
  trinhtuthuchien: string;
  cachthucthuchien: string;
  thanhphansoluonghoso: string;
  thoigiangiaiquyet: string;
  doituongthuchien: string;
  ketqua: string;
  yeucauthuchienthutuchanhchinh: string;
  lephi: string;
  taptin: string;
  donvitructhuoc: Donvitructhuoc;
  donvitructhuocid: number;
  quanlythongtinlinhvuc: QlttLinhVuc;
  quanlythongtinlinhvucid: number;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;
  getFiles : string[];
  coquanthuchien: string;
  donviid: number;
  tongso: number;
  tentat: string;
  
}